import { IMaterialEmissionFactor } from './types'
import http from '../../../../http'
import { API_URL } from '../../../../const'

// Dedicated packaging controller, not the food EmissionFactors route: the food controller's
// cross-type guard rejects a packaging id.
const PACKAGING_EMISSION_FACTORS_URL: string = `${API_URL}/PackagingEmissionFactors`

export const getMaterialEmissionFactor = (factorId: string) =>
  http.get(`${PACKAGING_EMISSION_FACTORS_URL}/${factorId}`)

export const updateMaterialEmissionFactor = (factorId: string, data: IMaterialEmissionFactor) =>
  http.put(`${PACKAGING_EMISSION_FACTORS_URL}/${factorId}`, { data })

export const createMaterialEmissionFactor = data =>
  http.post(`${PACKAGING_EMISSION_FACTORS_URL}`, { data })

export const deleteMaterialEmissionFactor = (factorId: string) =>
  http.delete(`${PACKAGING_EMISSION_FACTORS_URL}/${factorId}`)

export const publishMaterialEmissionFactor = (factorId: string) =>
  http.post(`${PACKAGING_EMISSION_FACTORS_URL}/publish/${factorId}`)

export const unPublishMaterialEmissionFactor = (factorId: string) =>
  http.delete(`${PACKAGING_EMISSION_FACTORS_URL}/unPublish/${factorId}`)

export const getMaterialEmissionFactorConfiguration = () =>
  http.get(`${PACKAGING_EMISSION_FACTORS_URL}/configuration`)
